module.exports = __webpack_public_path__ + "static/media/logoV1RAGEwhite.d66a400b.svg";